// extracted by mini-css-extract-plugin
export default {"zoomModal":"Kba-z"};